export function inviteOutcomeEvents(
    prevState,
    nextState,
    nicknameByUserId = {},
    currentUserId = null
) {
    const events = [];
    const prev = prevState && typeof prevState === "object" ? prevState : {};
    const next = nextState && typeof nextState === "object" ? nextState : {};
    const ids = new Set([...Object.keys(prev), ...Object.keys(next)]);
    const selfId = currentUserId != null && currentUserId !== ""
        ? String(currentUserId)
        : null;

    for (const id of ids) {
        if (selfId && String(id) === selfId) continue;

        const was = prev[id] || {};
        const now = next[id] || {};
        // Invitee clients also receive accept/decline events. Only the
        // sender has an outgoing `invited` row beforehand.
        if (!was.invited) continue;
        const name = nicknameByUserId[id] || "Player";
        const errorNow = now.inviteError ? String(now.inviteError) : "";
        const errorWas = was.inviteError ? String(was.inviteError) : "";

        if (errorNow && errorNow !== errorWas) {
            const lower = errorNow.toLowerCase();
            if (lower.includes("declined")) {
                events.push({
                    type: "error",
                    message: `${name} declined the invite`,
                    guestId: id,
                    clearError: true,
                });
            } else if (lower.includes("expired")) {
                events.push({
                    type: "warning",
                    message: `Invite to ${name} expired`,
                    guestId: id,
                    clearError: true,
                });
            } else {
                events.push({
                    type: "error",
                    message: errorNow,
                    guestId: id,
                    clearError: true,
                });
            }
            continue;
        }

        if (now.inviteAccepted && !was.inviteAccepted) {
            events.push({
                type: "success",
                message: `${name} accepted the invite`,
                guestId: id,
                clearError: false,
            });
        }
    }

    return events;
}
